type ApiViolation = {
    propertyPath?: string;
    message?: string;
};

export type FieldApiViolation = {
    fieldPath: string;
    message: string;
};

type StepWithValidation = {
    validate: string[];
};

const getApiErrorData = (error: unknown): Record<string, any> | undefined =>
    (error as any)?.response?.data ?? (error as any)?.data;

export const normalizeApiViolationPath = (propertyPath: string) =>
    propertyPath.replace(/\[([^\]]+)\]/g, ".$1").replace(/^\./, "");

export const getApiFieldViolations = (error: unknown): FieldApiViolation[] => {
    const violations = getApiErrorData(error)?.violations;

    if (!Array.isArray(violations)) {
        return [];
    }

    const fieldViolations: FieldApiViolation[] = [];

    for (const violation of violations as ApiViolation[]) {
        if (typeof violation.propertyPath !== "string" || typeof violation.message !== "string") {
            continue;
        }

        fieldViolations.push({
            fieldPath: normalizeApiViolationPath(violation.propertyPath),
            message: violation.message,
        });
    }

    return fieldViolations;
};

export const getApiErrorMessage = (error: unknown): string | undefined => {
    const data = getApiErrorData(error);
    return data?.detail ?? data?.["hydra:description"];
};

export const getStepIndexForFieldPath = (fieldPath: string, steps: StepWithValidation[]) =>
    steps.findIndex(step => step.validate.some(field => fieldPath === field || fieldPath.startsWith(`${field}.`)));
